<mat-card>
    
    <mat-card-header class="headerFlex">
        <span class="forceFloatRight">
            <button mat-icon-button color="primary" (click)="closeRecord()">
                <span class="centercloseBtn"><mat-icon>close</mat-icon></span> 
            </button>
         </span> 
        <mat-card-title>
            Resolved Match Task
            <help-text-btn class="align-help-text-btn" [helpTextId]="'ResolvedMatchTasks'"></help-text-btn>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <mat-divider></mat-divider>
        <br>
        <div class="row">
           <span class="header-no-space">Selected SSID from CALPADS Potential Matches ({{ studentLen }})</span> 
        </div>
        <div *ngIf="isLoading">
            <mat-spinner></mat-spinner>
        </div>

        <app-msg [msg]="msg" *ngIf="!msg.SUCCESS"></app-msg>

        <div *ngIf="msg.SUCCESS && !this.isLoading" class="margin-top-md">
            <div class="row   table-responsive">
                <mat-table [dataSource]="tableDataSourceSinf" (matSortChange)="setupSorting($event)" matSort
                    class="mat-elevation-z8">

                    <ng-container matColumnDef="Name">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                            Name
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            {{ displayNames(element) | titlecase }}<br>
                        </mat-cell>
                    </ng-container>
                    
                    <ng-container matColumnDef="SSID">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>SSID</mat-header-cell>
                        <mat-cell *matCellDef="let element">
                             {{element.Ssid }}
                        </mat-cell>
                    </ng-container>
                    
                    <ng-container matColumnDef="DOB">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>DOB</mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            {{element.StudentBirthDate | shortDateTime }}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="Gender">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Gender</mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            {{element.StudentGenderCode }}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="Birth City">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Birth City</mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            {{element.StudentBirthCity }}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="Current School District">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Current School District</mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            {{element.Senr?.ReportingLEA }}                            
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="Current Grade">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Current Grade</mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            {{element.GradeLevelCode }}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="Guardian1">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Guardian1</mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            {{element.Guardian1LastName ? element.Guardian1LastName +', ': '' }} {{element.Guardian1FirstName }}
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="Guardian2">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Guardian2</mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            {{element.Guardian2LastName ? element.Guardian2LastName +', ': '' }} {{element.Guardian2FirstName }}
                        </mat-cell>
                    </ng-container>
                    
                    <mat-header-row *matHeaderRowDef="displayedColumnsSinf"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: displayedColumnsSinf;"
                    [ngClass]="{'highlight-row': row.Ssid === matchedSSID}"
                    ></mat-row>
                </mat-table>
            </div>
        </div>
        <p>&nbsp;</p>
        <div class="row">
            <span class="header-no-space">Current MSIN Record</span>
        </div>

        <div *ngIf="msg.SUCCESS && !this.isLoading" class="margin-top-md">
            <div class="row   table-responsive">
                <mat-table [dataSource]="tableDataSource" (matSortChange)="setupSorting($event)" matSort
                    class="mat-elevation-z8">
                    <ng-container matColumnDef="Name">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                            Name
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            {{element.PERSON.LAST_NAME |
                            titlecase}}{{(element.SECOND_LAST_NAME
                            ? ' ' + element.SECOND_LAST_NAME + ',': ',') | titlecase}}
                            {{element.PERSON.FIRST_NAME |
                            titlecase}}
                            {{element.PERSON.MIDDLE_INITIAL | titlecase}}
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="SSID">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>SSID</mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            {{element.SSID}}
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="DOB">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>DOB</mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            {{element.DOB | shortDateTime }}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="Gender">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Gender</mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            {{element.SEX }}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="Birth City">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Birth City</mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            {{element.BIRTH_CITY }}
                        </mat-cell>
                    </ng-container>
                    
                    <ng-container matColumnDef="Current School District">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Current School District</mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            {{element.SCHOOL_DISTRICT }} - {{element.COUNTY_CODE}}{{element.SCHOOL_DISTRICT_CODE}}
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="Current Grade">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Current Grade</mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            {{element.GRADE }}
                        </mat-cell>
                    </ng-container>
                  
                    <ng-container matColumnDef="Guardian1">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Guardian1</mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            {{element.GUARDIAN_NAME_1 }}
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="Guardian2">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Guardian2</mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            {{element.GUARDIAN_NAME_2 }}
                        </mat-cell>
                    </ng-container>
                    

                    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
                </mat-table>
            </div>
        </div>
        <mat-card-actions>
            <div class="row"><p>&nbsp;</p></div>
            
            <div>                
                <div style="margin-bottom:-40px;">
                <button mat-raised-button (click)="showPreviousSSID()" color="primary">
                    Show Previous SSID
                </button>
            </div>
            <div style="margin-left:200px;">
                <mat-form-field class="field-full-width match-btn-height raise-label" appearance="fill" tabindex="0" floatLabel="always" >
                     <mat-label>Previous SSID</mat-label>
                    <input id="previousSSID"                        
                        type="text" 
                        matInput 
                        #message 
                        maxlength="100"
                        minlength="20"
                        ngDefaultControl
                        [(ngModel)]="myPreviousSsid"
                        class="form-control field-full-width transparent-input field-style"                         
                        readonly
                        disabled
                        >
                </mat-form-field>
                <span class="my-danger"
                style="float:right; margin-top:6px; margin-left:10px;"
                *ngIf="showPreviousSSIDErrorMsg"    
                >{{previousSSIDErrorMsg}}</span>
            </div>
                
            </div>
            <div *ngIf="isLoadingSSID">
                <mat-spinner></mat-spinner>
            </div>

        </mat-card-actions>

    </mat-card-content>
</mat-card>